let conditionTypes = {
    C: {
        label: 'Caries',
        value: 'caries',
        abbr: 'C'
    },
    Pl: {
        label: 'Plombed',
        value: 'plombed',
        abbr: 'Pl'
    },
    D: {
        label: 'Depulped',
        value: 'depulped',
        abbr: 'D'
    },
    P: {
        label: 'Pulpitis',
        value: 'pulpitis',
        abbr: 'P'
    },
    Pt: {
        label: 'Periodontitis',
        value: 'periodontitis',
        abbr: 'Pt'
    },
    Cr: {
        label: 'Crown',
        value: 'crown',
        abbr: 'Cr'
    },
    AT: {
        label: 'Artificial tooth',
        value: 'artificialtooth',
        abbr: 'AT'
    },
    I: {
        label: 'Implant',
        value: 'implant',
        abbr: 'I'
    },
    R: {
        label: 'Root',
        value: 'root',
        abbr: 'R',
        dose: 3
    },
    M: {
        label: 'Movability',
        value: 'movability',
        abbr: 'M'
    },
    DP: {
        label: 'Dental plaque',
        value: 'dentalplaque',
        abbr: 'DP'
    },
    TM: {
        label: 'Tooth missing',
        value: 'missing',
        abbr: 'TM'
    }
};

let conditionsArray = function (exclude = []) {
    return Object.freeze(Object.values(conditionTypes).filter(el => !exclude.includes(el.value)));
}

export {
    conditionTypes,
    conditionsArray,
};

export default function (status) {
    let conditioned;

    if (conditionTypes[status]) {
        conditioned = conditionTypes[status];
    } else {
        conditioned = {
            label: status
        }
    }

    return conditioned;
};
